var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.noChart)?_c('apex-chart',{staticClass:"chart",attrs:{"type":"line","width":_vm.chartWidth,"height":_vm.chartHeight,"options":_vm.chartOptions,"series":_vm.series}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }